module.exports = __webpack_public_path__ + "images/emoji/blue_car.d52e576063b3ccd3ae9f.png";